"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSetLine = void 0;
const common_1 = require("../../common");
const models_1 = require("../../sales-order/models");
class PackagingSetLine extends common_1.MongoSubDocument {
}
exports.PackagingSetLine = PackagingSetLine;
//# sourceMappingURL=packaging-set-line.model.js.map